import type { PricingStrategyProfileResponse } from '@/shared/api';

export type ComparisonValue = string | number | boolean | null;
export type ComparisonFormat = 'percent' | 'number' | 'text' | 'boolean' | 'time';

export interface ProfileComparisonRow {
  id: string;
  labelKey: string;
  detailKey: string;
  format: ComparisonFormat;
  values: ComparisonValue[];
}

export interface ProfileComparisonSection {
  id: string;
  titleKey: string;
  rows: ProfileComparisonRow[];
}

export const row = (
  id: string,
  labelKey: string,
  detailKey: string,
  format: ComparisonFormat,
  values: ComparisonValue[],
): ProfileComparisonRow => ({ id, labelKey, detailKey, format, values });

export function indexedRows<T>(
  profiles: PricingStrategyProfileResponse[],
  field: (profile: PricingStrategyProfileResponse) => T[],
  make: (index: number, values: Array<T | undefined>) => ProfileComparisonRow[],
) {
  const count = Math.max(0, ...profiles.map((profile) => field(profile).length));
  return Array.from({ length: count }, (_, index) =>
    make(
      index,
      profiles.map((profile) => field(profile)[index]),
    ),
  ).flat();
}

export const profileValues = <T>(
  profiles: PricingStrategyProfileResponse[],
  pick: (profile: PricingStrategyProfileResponse) => T,
) => profiles.map(pick);
